import { render } from "./question3.vue?vue&type=template&id=adcc8bac&scoped=true"
import script from "./question3.vue?vue&type=script&lang=js"
export * from "./question3.vue?vue&type=script&lang=js"

import "./question3.vue?vue&type=style&index=0&id=adcc8bac&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adcc8bac"]])

export default __exports__